import React from 'react';
import PropTypes from 'prop-types';
import { FormHelperText, Typography } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/InfoTwoTone';
import config from '../../config';
import i18n from '../../i18n';
import ImmediateFileUploader from '../common/ImmediateFileUploader';

const FormBudgetVoteFilesUploadField = ({
  input,
  label,
  meta: { error, touched },
  fileSizeLimitMegabytes,
  filesCountLimit,
  budgetId,
  acceptedMimeTypes,
  onDeleteUploadedFile,
}) => {
  const uploadUrl = `${config.API_URL}/public/budget/${budgetId}/files/upload`;

  return (
    <div>
      {label ? <Typography variant="caption">{label}</Typography> : null}
      <ImmediateFileUploader
        maxFiles={filesCountLimit}
        maxSizeBytes={fileSizeLimitMegabytes * 1024 * 1024}
        uploadUrl={uploadUrl}
        onFilesChanged={files => input.onChange(files)}
        accept={acceptedMimeTypes}
        //onDeleteUploadedFile={onDeleteUploadedFile}
      />
      {error && error !== i18n.t('surveySubmission.validation.fileInProgress') && touched && <FormHelperText error>{error}</FormHelperText>}
      {input.value && input.value.some(f => f.inProgress) && <div style={{ display: 'flex', alignItems: 'center' }}>
        <InfoIcon fontSize="small" />
        <Typography variant="caption" style={{ marginLeft: 4 }}>{i18n.t('surveySubmission.validation.fileInProgress')}</Typography>
      </div>}
    </div>
  );
};

FormBudgetVoteFilesUploadField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  fileSizeLimitMegabytes: PropTypes.number.isRequired,
  filesCountLimit: PropTypes.number.isRequired,
  budgetId: PropTypes.string.isRequired,
  acceptedMimeTypes: PropTypes.string,
  onDeleteUploadedFile: PropTypes.func.isRequired,
};

export default FormBudgetVoteFilesUploadField;



// WEBPACK FOOTER //
// ./src/components/form/FormBudgetVoteFilesUploadField.js